import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import analyticsService from '../services/analytics';
import axios from 'axios';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Configure axios to send a custom header for all future requests
    // This will tell the backend middleware not to track 404 errors
    axios.defaults.headers.common['X-Frontend-Handled-Error'] = 'true';
    
    // Track the 404 error when the component mounts
    // The analyticsService will handle duplicate prevention internally
    analyticsService.trackError('404 Not Found', {
      path: window.location.pathname,
      errorType: 'PAGE_NOT_FOUND',
      frontend_handled: true
    });
    
    // Clean up: Remove the custom header when the component unmounts
    return () => {
      delete axios.defaults.headers.common['X-Frontend-Handled-Error'];
    };
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%', // Use 100% to fill the parent's available height
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h3" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" gutterBottom>
        The page you're looking for does not exist.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/home')}>
        Go Home
      </Button>
    </Box>
  );
};

export default NotFound;
